import { useEffect } from 'react';

import map from 'lodash/map';

import { Card } from 'src/app/components/Elements/Card';
import StandardPage from 'src/app/components/Elements/Page/Standard';
import Spinner from 'src/app/components/Elements/Spinner';
import { Typography } from 'src/app/components/Elements/Typography';
import { ActiveOrder } from 'src/app/components/Models/Order/ActiveOrder';
import { Order } from 'src/app/components/Models/Order/Order';
import type { Order as OrderType } from 'src/app/types';

import { NoCardItem } from './NoCardItem';
import { OrderHistoryContainer, SectionHeader } from './styles';
import { useOrderHistoryAnalytics } from './useOrderHistoryAnalytics';

interface OrderHistoryPageProps {
  isFetching: boolean;
  ordersActive?: OrderType[];
  ordersCompleted?: OrderType[];
  dispatchGetOrderHistory: () => void;
}

export const OrderHistoryPage = ({
  isFetching,
  ordersActive,
  ordersCompleted,
  dispatchGetOrderHistory,
}: OrderHistoryPageProps) => {
  useEffect(() => {
    dispatchGetOrderHistory();
  }, [dispatchGetOrderHistory]);

  useOrderHistoryAnalytics(ordersActive);

  return (
    <StandardPage alignment={'left'}>
      <OrderHistoryContainer>
        <Typography variant={'h1'} marginBottom={'s5'}>
          Your Orders
        </Typography>
        {isFetching ? (
          <Spinner centered />
        ) : (
          <>
            {ordersActive && ordersActive.length !== 0 && (
              <>
                <SectionHeader>IN PROGRESS</SectionHeader>
                <Card>
                  {map(
                    ordersActive,
                    (order, index) =>
                      order.items && order.items.length > 0 && <ActiveOrder order={order} index={index} />
                  )}
                </Card>
              </>
            )}
            {ordersCompleted && ordersCompleted.length !== 0 && (
              <>
                <SectionHeader>PAST ORDERS</SectionHeader>
                <Card>
                  {map(ordersCompleted, (order, index) => (
                    <Order order={order} index={index} />
                  ))}
                </Card>
              </>
            )}
            {(!ordersActive || ordersActive.length === 0) && (!ordersCompleted || ordersCompleted.length === 0) && (
              <Card>
                <NoCardItem />
              </Card>
            )}
          </>
        )}
      </OrderHistoryContainer>
    </StandardPage>
  );
};
